module.exports = {"540229100":"德吉林镇","540229200":"帕当乡","540229201":"康雄乡","540229202":"普松乡","540229203":"然巴乡","540229204":"茶巴乡","540229205":"切洼乡","540229206":"母乡","540229207":"仁布乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540229.json
// module id = 2500
// module chunks = 0